import * as React from 'react';
import { cn } from '@/lib/utils';

type Tom = 'neutro' | 'sucesso' | 'alerta' | 'perigo' | 'marca';

const TONS: Record<Tom, string> = {
  neutro: 'bg-silenciado text-silenciado-texto border-borda',
  sucesso: 'bg-status-agendado-fundo text-status-agendado-texto border-status-agendado-borda',
  alerta: 'bg-status-pendencia-fundo text-status-pendencia-texto border-status-pendencia-borda',
  perigo: 'bg-status-devolvido-fundo text-status-devolvido-texto border-status-devolvido-borda',
  marca: 'bg-status-enviado-fundo text-status-enviado-texto border-status-enviado-borda',
};

interface EtiquetaProps extends React.ComponentProps<'span'> {
  tom?: Tom;
}

export function Etiqueta({ className, tom = 'neutro', ...props }: EtiquetaProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONS[tom],
        className,
      )}
      {...props}
    />
  );
}
